import { BaseModel } from "sjs-base-model";

export default class IstitutoFinanziarioModel extends BaseModel {
    public readonly chiave: string = "";
    public readonly valore: string = "";

    /* public readonly idIstituto: string = "";
    public readonly Denominazione: string = "";
    public readonly Piva: string = "";
    public readonly CodFisc: string = "";
    public readonly Iban1: string = "";
    public readonly Iban2: string = "";
    public readonly Abi: string = "";
    public readonly idTipoIstituto: number = 0;
    public readonly TanApplicato: number = 0;
    public readonly ProgressivoRappCSE: number = 0;
    public readonly PercentualeMontante: number = 0;
    public readonly ProvvigioneCollaborazione: number = 0;
    public readonly CodDettaglioCollaboratore: string = "";
    public readonly LogFilialeCSE: number = 0;
    public readonly LogABICSE: number = 0;
    public readonly DenomBancaAccredito: string = "";
    public readonly FgCumuloCapitaleFinanziato: string = "";
    public readonly IdSAE : number = 0;
    public readonly IdRAE : number = 0;
    public readonly IdFormaGiuridica: number = 0;
    public readonly TipoCDG: string = "";
    public readonly Cdg: number = 0;
    public readonly CodTitoloOnorifico: number = 0;
    public readonly CodIstat: string = "";
    public readonly FgBuonaPrassi: string = ""; */
    /*
     * Client-Side properties (Not from API)
     */
    // public noneApiProperties: unknown = null;
    constructor(data: Partial<IstitutoFinanziarioModel>) {
        super();

        this.update(data);
    }
}
